import { createFileRoute } from '@tanstack/react-router';

import { ProtocolePage } from '@support';

export const Route = createFileRoute('/_app/protocole')({
  component: ProtocolePage,
});
